// src/services/cloudBackup.js
// Deletes everything cloud backup keeps for one person in this app's
// Firestore: the four collections storageService writes under
// users/{uid} (data, moduleProgress, toolData, toolUsage) and the stats on
// the users/{uid} document itself.
//
// Takes `db` as a parameter (rather than importing services/firebase.js) so
// scripts/test-cloud-backup-deletion.mjs can run this exact code against the
// emulators. Throws if anything fails, so the caller can say so plainly.

import { collection, doc, getDocs, deleteDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export const CLOUD_BACKUP_COLLECTIONS = ['data', 'moduleProgress', 'toolData', 'toolUsage'];

export async function deleteCloudBackup(db, userId) {
  if (!userId) throw new Error('No user to delete a cloud backup for.');

  let deleted = 0;
  for (const name of CLOUD_BACKUP_COLLECTIONS) {
    const snapshot = await getDocs(collection(db, 'users', userId, name));
    await Promise.all(snapshot.docs.map((entry) => deleteDoc(entry.ref)));
    deleted += snapshot.size;
  }

  // firebase.rules never lets anyone delete users/{uid}, so overwrite it
  // (no merge) to drop the stats and anything else stored there. setDoc also
  // works when the document was never created, which updateDoc does not.
  await setDoc(doc(db, 'users', userId), { cloudBackupDeletedAt: serverTimestamp() });

  return { deleted };
}
